
import {
    Text,
    Flex
} from "@chakra-ui/react";

import { CreditCardIcon } from "../../../styles/icons/CreditCardIcon";
import { RightArrow } from "../../../styles/icons/RightArrow";
export function SectionCreditCardReviewModal({oldValue, newValue, nameSection}) {

    return (
        <Flex flexDir="column" gap="26px" >
        <Flex gap=".4rem" margin="1rem 0 0" >
            <CreditCardIcon size={22} />
            <Text
                fontSize="16px"
                color="rgba(0, 0, 0, 1)"
                fontWeight="600"
                fontFamily="Hero New"
                lineHeight="22.38px"
            >{nameSection}</Text>
        </Flex>
        <Flex
            w="600px"
            justifyContent="space-between">
            <Flex
                alignItems="center"
                gap="8px"
            >
                <Text
                    color={oldValue?.organizedRatesDayOld?.ONLINE[0]?.day !== newValue?.organizedRatesDayNew?.ONLINE[0]?.day ? "rgba(138, 148, 168, 1)" : "rgba(195, 202, 215, 1)"}
                    fontFamily="Hero New"
                    fontSize="16px"
                    lineHeight="16px"
                >Link</Text>
                {oldValue &&

                    <Flex
                        alignContent="center"
                        alignItems="center"
                        gap="8px"
                    >

                        {newValue && (oldValue?.organizedRatesDayOld?.ONLINE[0]?.day !== newValue?.organizedRatesDayNew?.ONLINE[0]?.day) ?
                            <>
                                <Text
                                    color={"#000000"}
                                >
                                    D + {oldValue?.organizedRatesDayOld?.ONLINE[0]?.day}
                                </Text>
                                <RightArrow />
                                <Text
                                    fontWeight="bold"
                                    color="rgba(212, 136, 6, 1)"
                                >
                                    D + {newValue?.organizedRatesDayNew?.ONLINE[0]?.day}
                                </Text>
                            </> :
                            <Text
                                fontSize="16px"
                                color="rgba(195, 202, 215, 1)"
                                lineHeight="26px"
                                fontFamily="Hero New"
                            >
                                D + {oldValue?.organizedRatesDayOld?.ONLINE[0]?.day}
                            </Text>

                        }
                    </Flex>
                }
            </Flex>
            <Flex
                alignItems="center"
                gap="8px"
            >
                <Text
                    color={oldValue?.organizedRatesDayOld?.POS[0]?.day !== newValue?.organizedRatesDayNew?.POS[0]?.day ? "rgba(138, 148, 168, 1)" : "rgba(195, 202, 215, 1)"}
                    fontFamily="Hero New"
                    fontSize="16px"
                    lineHeight="16px"
                >POS</Text>
                {oldValue &&

                    <Flex
                        alignContent="center"
                        alignItems="center"
                        gap="8px"
                    >

                        {newValue && (oldValue?.organizedRatesDayOld?.POS[0]?.day !== newValue?.organizedRatesDayNew?.POS[0]?.day) ?
                            <>
                                <Text
                                    color="#000000"
                                >
                                    D + {oldValue?.organizedRatesDayOld?.POS[0]?.day}
                                </Text>

                                <RightArrow />
                                <Text
                                    fontWeight="bold"
                                    color="rgba(212, 136, 6, 1)"
                                >
                                    D + {newValue?.organizedRatesDayNew?.POS[0]?.day}
                                </Text>
                            </> :
                            <Text
                                fontSize="16px"
                                color="rgba(195, 202, 215, 1)"
                                lineHeight="26px"
                                fontFamily="Hero New"
                            >
                                D + {oldValue?.organizedRatesDayOld?.POS[0]?.day}
                            </Text>

                        }
                    </Flex>
                }
            </Flex>
            <Flex
                alignItems="center"
                gap="8px"
            >
                <Text
                    color={oldValue?.organizedRatesDayOld?.TAP_TO_PAY[0]?.day !== newValue?.organizedRatesDayNew?.TAP_TO_PAY[0]?.day
                        ? "rgba(138, 148, 168, 1)" : "rgba(195, 202, 215, 1)"}
                    fontFamily="Hero New"
                    fontSize="16px"
                    lineHeight="16px"
                >Tap</Text>
                {oldValue &&

                    <Flex
                        alignContent="center"
                        alignItems="center"
                        gap="8px"
                    >


                        {newValue && (oldValue?.organizedRatesDayOld?.TAP_TO_PAY[0]?.day !== newValue?.organizedRatesDayNew?.TAP_TO_PAY[0]?.day) ?
                            <>

                                <Text
                                    color="#000000"
                                >
                                    D + {oldValue?.organizedRatesDayOld?.TAP_TO_PAY[0]?.day}
                                </Text>
                                <RightArrow />
                                <Text
                                    fontWeight="bold"
                                    color="rgba(212, 136, 6, 1)"
                                >
                                    D + {newValue?.organizedRatesDayNew?.TAP_TO_PAY[0]?.day}
                                </Text>
                            </> :
                            <Text
                                fontSize="16px"
                                color="rgba(195, 202, 215, 1)"
                                lineHeight="26px"
                                fontFamily="Hero New"
                            >
                                D + {oldValue?.organizedRatesDayOld?.TAP_TO_PAY[0]?.day}
                            </Text>
                        }
                    </Flex>
                }
            </Flex>
        </Flex>
    </Flex>
    )

}